import React, {useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react';
import parse from "html-react-parser";
import {hasChart, mrbgStore, setChartKey} from './mrbgRedux/index.js';
import MrbgPieChart from './MrbgPieChart.jsx';
import MrbgLineChart from './MrbgLineChart.jsx';
import chartStyle from '../../static/css/MP_charts.module.css'

function MrbgFullChart({id,title}){

  const
    [chartInfo,setChartInfo] = useState( mrbgStore.getState().mrbgVars[id] ),
    [chartName,setChartName] = useState( mrbgStore.getState().dynamicChartKey[id]?.cName );

  useEffect(() => {
    if( chartInfo && !chartName )
      mrbgStore.dispatch(setChartKey({id,chartKey:Object.keys(chartInfo)[0]}) )
  }, [chartInfo,chartName]);
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setChartInfo( mrbgStore.getState().mrbgVars[id] )
      setChartName( mrbgStore.getState().dynamicChartKey[id]?.cName )
    })
    mrbgStore.dispatch(hasChart())
    return () =>unsubscribe();
  },[])

  return(
    <div id={id} className={chartStyle.fullChartsFrame}>
      <div className={chartStyle.MP_frameH2}>
        <h2>{title}</h2>
      </div>
      <div className={chartStyle.fullChart}>
        {
          chartInfo?
            <>
              <h3>{title}</h3>
              <ChSemiCircle {...{chartInfo,chartName}} />
              <ChInfo {...{chartInfo,chartName,chartID:id}} />
              <div className={chartStyle.FChPFrame}>
                <MrbgPieChart {...{chartInfo,chartID:id,radius:75}}/>
              </div>
              <ChBLFrame {...{chartInfo,chartName,chartID:id}} />
              <div className={chartStyle.extraDescription}>{chartInfo[chartName]?.description}</div>
            </>:
            <div></div>
        }
      </div>
    </div>
  )
}
function ChSemiCircle({chartInfo,chartName}){

  const
    scpTxt = useRef(null),
    sclTxt = useRef(null),
    pointsKey = Object.keys(chartInfo[chartName]?.points || []),
    lastX = pointsKey[pointsKey.length-1] || '',
    max = Object.values(chartInfo[chartName]?.points || []).max(),
    percent = chartInfo[chartName]?.points[lastX] && max? Math.round(chartInfo[chartName].points[lastX]/max*10000)/100: 0,
    [pos, setPos] = useState({ pX: 0, lX: 0 });

  useLayoutEffect(() => {
    if( !scpTxt.current || !sclTxt.current ) return;

    function measure() {
      const pBox = scpTxt.current.getBBox();
      const lBox = sclTxt.current.getBBox();

      // اگر هنوز width صفره، یعنی فونت لود نشده → دوباره فردا تلاش کن
      if( pBox.width === 0 || lBox.width === 0 ){
        // requestAnimationFrame(measure);
        return;
      }

      const totalWidth = pBox.width + lBox.width;
      const gap = 8;

      setPos({
        pX: -(totalWidth/2)+pBox.width/2-gap/2,
        lX: +(totalWidth/2)-lBox.width/2+gap/2
      });
    }

    requestAnimationFrame(measure);
  }, [percent, chartName]);


  return(
    <div className={chartStyle.ChSemiCircle}>
      <svg className={chartStyle.semiCircleMax} viewBox="0 0 220 140" xmlns="http://www.w3.org/2000/svg">
        <path className={chartStyle.SCPathFrame} d="M2,130 a108,120 0,0,1, 216,0 q0,8 -8,8 q-8,0 -8,-8 a92,104, 0, 0, 0, -184,0 q0,8 -8,8 q-8,0 -8,-8 z" />
        <path className={chartStyle.SCPathChart} d="M10.5,128 a99.75,-109.5 0,0,1 199.5, 0" style={{strokeDashoffset:Math.min(((100-percent)*329/100),328)}} />
        <path className={chartStyle.SCCenterCircle} d="M19,140 v-6 a89,105, 0, 0, 1, 182,0 v6z" />
        <g textAnchor="middle" transform="translate(110,95)">
          <text className={chartStyle.SCPercent} x={pos.pX} ref={scpTxt}>{percent}%</text>
          <text className={chartStyle.SCLabel} x={pos.lX} ref={sclTxt}>OF MAX</text>
        </g>
        <text className={chartStyle.SCTitle} x="110" y="120">{lastX}</text>
      </svg>
    </div>
  )
}
function ChInfo({chartID,chartInfo,chartName}){

  const
    pointsValue = Object.values(chartInfo[chartName]?.points || []),
    [pointName,setPointName] = useState( mrbgStore.getState().dynamicChartKey[chartID]?.pName ),
    [pointVal,setPointVal] = useState('---'),
    [pointPercent,setPointPercent] = useState('---'),
    [growthVal,setGrowthVal] = useState(''),
    [growthPer,setGrowthPer] = useState(''),
    [growthIcn,setGrowthIcn] = useState(''),
    [maxDV,setMaxDV] = useState('---'),          // MAX DIFF VALUE
    [maxDP,setMaxDP] = useState('---'),          // MAX DIFF PERCENT
    [maxDI,setMaxDI] = useState('check'),        // MAX DIFF ICON
    [minDV,setMinDV] = useState('---'),
    [minDP,setMinDP] = useState('---'),
    [minDI,setMinDI] = useState('check'),
    [avgDV,setAvgDV] = useState('---'),
    [avgDP,setAvgDP] = useState('---'),
    [avgDI,setAvgDI] = useState('check'),
    [max,setMax] = useState(pointsValue.max()),
    [min,setMin] = useState(pointsValue.min()),
    [avg,setAvg] = useState(chartInfo[chartName]?.total/pointsValue.length || 0),

    calcInfo = useCallback(()=>{
      var
        pointsKey = pointName? Object.keys(chartInfo[chartName].points).indexOf(pointName): undefined,
        ppn = pointsKey? Object.keys(chartInfo[chartName].points)[pointsKey-1]: undefined, // PRE POINT NAME

        GV = ppn!==undefined? chartInfo[chartName].points[pointName]-chartInfo[chartName].points[ppn]: '---',
        GP = ppn!==undefined? `${Math.abs(Math.round(GV/chartInfo[chartName].points[ppn]*10000)/100)} %`: '---',
        GI = GV==0 || GV=='---'? 'check': (GV>0)? 'caret-up': 'caret-down',

        mxD = pointName? chartInfo[chartName].points[pointName]-max: '---',
        mxP = pointName? `${Math.abs(Math.round(mxD/max * 10000)/100)} %`: '---',
        mxI = mxD==0 || mxD=='---'? 'check': (mxD>0)? 'caret-up': 'caret-down',

        mnD = pointName? chartInfo[chartName].points[pointName]-min: '---',
        mnP = pointName? `${Math.abs(Math.round(mnD/min * 10000)/100)} %`: '---',
        mnI = mnD==0 || mnD=='---'? 'check': (mnD>0)? 'caret-up': 'caret-down',

        AD = pointName? chartInfo[chartName].points[pointName]-avg: '---',
        AP = pointName? `${Math.abs(Math.round(AD/avg * 10000)/100)} %`: '---',
        AI = AD==0 || AD=='---'? 'check': (AD>0)? 'caret-up': 'caret-down';

      setPointVal    ( pointName? chartInfo[chartName]?.points[pointName]:'---' );
      setPointPercent( pointName? Math.round(((chartInfo[chartName]?.points[pointName]/chartInfo[chartName]?.total) || 0)*10000)/100: '---' )

      GV === '---'?
        setGrowthVal( GV ):
        setGrowthVal( Math.abs(GV).toFixed(2).replace(/\.00$/,'').toPrice() || '---' );
      setGrowthPer   ( GP )
      setGrowthIcn   ( GI )

      mxD === '---'?
        setMaxDV( mxD ):
        setMaxDV( Math.abs(mxD).toFixed(2).replace(/\.00$/,'').toPrice() )
      setMaxDP( mxP )
      setMaxDI( mxI )

      mnD === '---'?
        setMinDV( mnD ):
        setMinDV( Math.abs(mnD).toFixed(2).replace(/\.00$/,'').toPrice() )
      setMinDP( mnP )
      setMinDI( mnI )

      AD === '---'?
        setAvgDV( AD ):
        setAvgDV( Math.abs(AD).toFixed(2).replace(/\.00$/,'').toPrice() )
      setAvgDP( AP )
      setAvgDI( AI )

    },[chartName,pointName,max,min,avg]);

  function scrlTo( e,multiplier ){
    var elm = e.target.parentElement.firstChild;
    elm.scrollBy({left: (elm.offsetWidth-70)*multiplier,behavior: 'smooth'})
  }

  useEffect(()=>{
    setMax( pointsValue.max() )
    setMin( pointsValue.min() )
    setAvg(chartInfo[chartName]?.total/pointsValue.length || 0 )
  },[chartName]);
  useEffect(()=>{
    calcInfo()
  },[calcInfo]);
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setPointName( mrbgStore.getState().dynamicChartKey[chartID]?.pName );
    })
    return () =>unsubscribe();
  },[])

  return(
    <div className={chartStyle.fullChInfo}>
      <div className={chartStyle.FDChBtnFrame}>
        <div>
          <ul className={chartStyle.FDChBtnList}>
            {
              Object.keys(chartInfo).map((cName,i)=>{
                return(
                  <li className={cName==chartName? chartStyle.activeBtn: ''} onClick={()=>mrbgStore.dispatch(setChartKey({id:chartID,chartKey:cName}))} key={i}>
                    {chartInfo[cName].btnTxt}
                  </li>
                )
              })
            }
          </ul>
        </div>
        <i className={`${chartStyle.dynamicChartsBtn_RS} fa-solid fa-caret-right`} onClick={e=>scrlTo(e,1)}></i>
        <i className={`${chartStyle.dynamicChartsBtn_LS} fa-solid fa-caret-left`} onClick={e=>scrlTo(e,-1)}></i>
      </div>
      <div className={`${chartStyle.FChDescription} ${chartStyle.flexRowDesk}`}>
        <ul className={chartStyle.FChIMainData}>
          <li className={chartStyle.FChI_val}>{pointVal==='---'? pointVal: parseFloat(pointVal).toFixed(2).replace(/\.00$/,'').toPrice()}</li>
          <li className={chartStyle.FChI_percent}>
            {pointPercent==='---'? pointPercent: `${pointPercent} %`} <span>OF TOTAL</span>
          </li>
          <li className={chartStyle.FChI_colName}>
            {pointName||'---'}
            <span>(Click the chart points.)</span>
          </li>
        </ul>
        <ul className={chartStyle.FChIGrowth}>
          <li className={chartStyle.organizationalGradiant}>GROWTH</li>
          <li>
            {growthVal}
            <i className={`fa-solid fa-${growthIcn} ${chartStyle['fa-'+growthIcn]}`}></i>
            {growthPer}
          </li>
        </ul>
        <div className={chartStyle.FChITable}>
          <table>
            <tbody>
              <tr>
                <th className={chartStyle.organizationalGradiant}>MAX</th>
                <td>{max.toFixed(2).replace(/\.00$/,'').toPrice()}</td>
                <td>{maxDV}</td>
                <td>
                  <i className={`fa-solid fa-${maxDI} ${chartStyle['fa-'+maxDI]}`}></i>
                </td>
                <td>{maxDP}</td>
                <td>rel to max</td>
              </tr>
              <tr>
                <th className={chartStyle.organizationalGradiant}>MIN</th>
                <td>{min.toFixed(2).replace(/\.00$/,'').toPrice()}</td>
                <td>{minDV}</td>
                <td>
                  <i className={`fa-solid fa-${minDI} ${chartStyle['fa-'+minDI]}`}></i>
                </td>
                <td>{minDP}</td>
                <td>
                  rel to min
                </td>
              </tr>
              <tr>
                <th className={chartStyle.organizationalGradiant}>AVG</th>
                <td>{avg.toFixed(2).replace(/\.00$/,'').toPrice()}</td>
                <td>{avgDV}</td>
                <td>
                  <i className={`fa-solid fa-${avgDI} ${chartStyle['fa-'+avgDI]}`}></i>
                </td>
                <td>{avgDP}</td>
                <td>
                  rel to avg
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
function ChBLFrame({chartID,chartInfo,chartName}){

  const
    maxHeight = 170,
    smooth = 0.2,
    max = Object.values(chartInfo[chartName]?.points || []).max();

  return(
    <div className={chartStyle.FChBLFrame}>
      <div className={chartStyle.FChScrollFrame}>
        <ul className={chartStyle.yAxis}>
          {
            [...Array(5)].map((v,k)=>{
              var
                val = parseFloat(max)/4*k,
                d = Math.floor(val).toString().length-1,
                dev = Math.floor(d/3),
                unit,
                title = {
                  1: 'هزار',
                  2: 'میلیون',
                  3: 'میلیارد',
                  4: 'میلیارد هزار',
                };

							val = Math.round((val/Math.pow(10,dev*3))*10)/10;
              unit =
                ( dev<5 )?
                ['',' K',' M',' G', ' T'][dev]:
                ` * 10^(${dev})`;

              return(
                <li key={k}>
                  <div title={title[dev]? parse("&#x202B;")+val+title[dev]: ''}>{val+unit}</div>
                  <div></div>
                </li>
              )
            })
          }
        </ul>
        <div className={chartStyle.FChBLList} style={{width:`${(Object.values(chartInfo[chartName]?.points || []).length*30)}px`}}>
          <svg className={chartStyle.LChSvg} viewBox={`0 0 ${Object.values(chartInfo[chartName]?.points || []).length*30} ${maxHeight}`} version="1.1" xmlns="http://www.w3.org/2000/svg">
            <MrbgLineChart {...{chartID,chartInfo,maxHeight:maxHeight,smooth:smooth}} />
          </svg>
        </div>
      </div>
    </div>
  )
}
export default MrbgFullChart;